import { ReportsRepository } from './repository';
import { getAuthToken } from '../../auth/tokenProvider';

let instance: ReportsRepository | null = null;

export function getReportsRepository(getToken?: () => Promise<string | null>): ReportsRepository {
  if (!instance) {
    instance = new ReportsRepository(getToken ?? getAuthToken);
  }
  return instance;
}
